import { render, staticRenderFns } from "./whatsapplog.vue?vue&type=template&id=f8c3e668&"
import script from "./whatsapplog.vue?vue&type=script&lang=js&"
export * from "./whatsapplog.vue?vue&type=script&lang=js&"
import style0 from "./whatsapplog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports